import React, { FC, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { withProcedureWraper } from "../..";
import { Box } from "../../../../components/box";
import { useSelector } from "../../../../store/store";
import { getDDMMYYYFormat, getUCTDate } from "../../../../helper/dateTimeHelper";
import { TrainingService } from "../../../../services/training/training.service";
import { Col, Container, Row } from "react-bootstrap";
import { Button } from "../../../../modules/button";
import { courseStatus, requestStatus } from "../../../../constants/statusConstants";
import { CreateNotification } from "../../../../components/notifier";
import { MailService } from "../../../../services/mail/mail.service";
import { mailRegexs } from "../../../../constants/mailTemplateConstants";
import { getEnv } from "../../../../AppConfigs";
import { Routes } from "../../../../AppRoutes";
import { Table } from "../../../../modules/table";
import { Icon } from "../../../../components/icon";

const siteUrl = getEnv("REACT_APP_APPROVER_TRANING_PLAN_URL");

export const ProcedureTrainingPlanDetailPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const [plan, setPlan] = useState(null as any);
  const [approvalComment, setApprovalComment] = useState("");
  const { plancode, id } = useRouteMatch().params as any;
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username.toLowerCase();

  const getTrainingPlanDetail = () => {
    TrainingService.getTrainingPlanById(id).then(
      (res) => {
        setPlan(res);
        setApprovalComment(res.fields.eApprovalComment);
      },
      () => {
        setPlan({});
      },
    );
  };

  const getCourses = () => {
    return TrainingService.getTrainingCourseByPlanCode(plancode).then(
      (res) => {
        return { data: res.reverse(), count: res.length };
      },
      () => {
        return { data: [], count: 0 };
      },
    );
  };

  const sendMail = async (status: string) => {
    const template = mailtemplates.find((m: any) => m.eMailType === "TPN");
    const statusText = status === requestStatus.approved ? "duyệt" : "từ chối";
    const content = template.eContent
      .replace(mailRegexs.zero, plan.createdBy.user.displayName)
      .replace(mailRegexs.one, statusText)
      .replace(mailRegexs.siteUrl, siteUrl);
    const subject = template.eSubject.replace("{0}", statusText);
    const message = MailService.buildMailMesssage(subject, content, "html", plan.createdBy.user.email);
    await MailService.sendMail(message);
  };

  const onApproval = (status: any) => {
    const { fields } = plan;
    fields.eApprovalComment = approvalComment;
    fields.eStatus = status;
    fields.eApprovalDate = getUCTDate();

    TrainingService.updateTrainingPlan(plan.id, fields)
      .then((res) => {
        CreateNotification({ title: "Thành công", body: `Chỉnh sửa thành công.`, icon: "/icons/success.png" });
        sendMail(status);
        goBack();
      })
      .catch((err) => {
        CreateNotification({ title: "Thất bại", body: `Chỉnh sửa thất bại.`, icon: "/icons/error.png" });
      });
  };

  const goBack = () => {
    history.goBack();
  };

  const checkEdit = () => {
    return !plan.fields.eApprovalBy;
  };

  useEffect(() => {
    getTrainingPlanDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="ProcedureTrainingPlanPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={goBack}>
              <Icon.ArrowLeft />
            </div>
            {"Danh sách kế hoạch"}
          </div>
        </div>
        <Box title={"Chi tiết kế hoạch"}>
          <Container>
            <Row>
              <Col xs={12} sm={12} md={{ span: 8, offset: 2 }}>
                {plan && (
                  <div className="d-flex align-items-center flex-column">
                    <div className="ProcedureTrainingPlanPage__title py-4">{"Chi tiết kế hoạch"}</div>
                    <div className="ProcedureTrainingPlanPage__body">
                      <div className="d-flex">
                        <div className="ProcedureTrainingPlanPage__body__item">
                          <div className="ProcedureTrainingPlanPage__body__item__label">{"Mã kế hoạch:"}</div>
                          <div className="ProcedureTrainingPlanPage__body__item__value">{plan.fields.PlanCode}</div>
                        </div>
                        <div className="ProcedureTrainingPlanPage__body__item">
                          <div className="ProcedureTrainingPlanPage__body__item__label">{"Kế hoạch:"}</div>
                          <div className="ProcedureTrainingPlanPage__body__item__value">{plan.fields.Title}</div>
                        </div>
                      </div>

                      <div className="pt-3">
                        <Box
                          title="Danh sách lớp học"
                          titleRight={
                            currentUserName === plan.createdBy.user.email.toLowerCase() && (
                              <div
                                className="btnPlus"
                                onClick={() =>
                                  history.push(
                                    Routes.procedureTrainingCourseCreate.path
                                      .replace(":plancode", plancode)
                                      .replace(":id", "0"),
                                  )
                                }
                              >
                                <Icon.Plus />
                                {"Thêm lớp học"}
                              </div>
                            )
                          }
                        >
                          <Table
                            className="table"
                            onRowClick={(item) =>
                              history.push(Routes.procedureTrainingCourseDetail.path.replace(":id", item.id))
                            }
                            structure={[
                              {
                                name: "Lớp học",
                                render: (item) => item.fields.Title,
                              },
                              {
                                name: "Ngày tổ chức",
                                render: (item) => getDDMMYYYFormat(item.fields.eStartDate),
                              },
                              {
                                name: "Ngày kết thúc",
                                render: (item) => getDDMMYYYFormat(item.fields.eEndDate),
                              },
                              {
                                name: "Địa điểm tổ chức",
                                render: (item) => item.fields.eLocation,
                              },
                              {
                                name: "Số lượng học viên",
                                render: (item) => item.fields.eNoOfTrainee,
                              },
                              {
                                name: "Giáo viên",
                                render: (item) => item.fields.eTeacher,
                              },
                            ]}
                            onFetchData={getCourses}
                          />
                        </Box>
                      </div>
                      {plan.fields.eApprovalComment && (
                        <div className="InputWraper">
                          <div className="mb-2 ProcedureTrainingPlanPage__body__item__label">Approval's comments</div>
                          <div className="wraper">
                            <div>{plan.fields.eApprovalComment}</div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="ProcedureTrainingPlanPage__footer w-100">
                      {currentUserName !== plan.createdBy.user.email.toLowerCase() &&
                        plan.fields.eStatus === requestStatus.submitted && (
                          <>
                            <div className="InputWraper">
                              <div className="mb-2">{"Comments"}</div>
                              <div className="wraper">
                                <div className="input">
                                  <textarea
                                    value={approvalComment}
                                    onChange={(e) => setApprovalComment(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="d-flex justify-content-center">
                              <div className="px-2">
                                <Button
                                  className="mr5"
                                  buttonType="success"
                                  label="Phê duyệt"
                                  onClick={() => {
                                    onApproval(courseStatus.approved);
                                  }}
                                />
                              </div>
                              <div className="px-2">
                                <Button
                                  buttonType="grey"
                                  label="Từ chối"
                                  onClick={() => {
                                    onApproval(courseStatus.rejected);
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      {currentUserName === plan.createdBy.user.email.toLowerCase() && checkEdit() && (
                        <div className="d-flex justify-content-center">
                          <Button
                            className="mr5"
                            buttonType="success"
                            label="Chỉnh sửa"
                            onClick={() =>
                              history.push(Routes.procedureTrainingPlanCreate.path.replace(":id", plan.id))
                            }
                          />
                          <Button buttonType="grey" label="Hủy" onClick={() => history.goBack()} />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </Box>
      </div>
    </div>
  );
});
